import { featureKey, reducers } from './store/reducers'

import { EffectsModule } from '@ngrx/effects'
import { NgModule } from '@angular/core'
import { ScopeConfigurationEffects } from './store/effects/scope-configuration.effects'
import { ScopeOverviewEffects } from './store/effects/scope-overview.effect'
import { StoreModule } from '@ngrx/store'

const EFFECTS = [ScopeOverviewEffects, ScopeConfigurationEffects]

@NgModule({ imports: [StoreModule.forFeature(featureKey, reducers), EffectsModule.forFeature(EFFECTS)] })
export class ScopeOverviewNgrxModule {}
